import React, { useState } from 'react';

import {Button, Col, Row, notification, Popover, Divider} from 'antd';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus, faTrash, faPen} from '@fortawesome/pro-solid-svg-icons';

import {FormularioCadastroProduto} from '../../cadastro/formulario-cadastro-produto';
import { useDispatch, useSelector } from 'react-redux';
import { useProduto } from '../../useProduto';
import { atualizaBuscandoProdutos, atualizaListaProdutos, atualizaListaProdutosAposRemover } from '../store/gerenciaProdutoReducer';


const { success } = notification

const AcoesCrudProduto = ({
    getApi, 
    createProps={
        type: 'primary',
        icon: <span><FontAwesomeIcon icon={faPlus} />&nbsp;</span>
    }, deleteProps={
        type: "danger",
        icon: <span><FontAwesomeIcon icon={faTrash} />&nbsp;</span>
    }, editProps={
        icon: <span><FontAwesomeIcon icon={faPen} />&nbsp;</span>
    },
    formCadastroProdutoProps
})=> {
    const [cadastroProdutosAberto, setCadastroProdutosAberto] = useState(false);
    const [cadastroProdutoKey, setCadastroProdutoKey] = useState(1);
    const {produtosSelecionados, filtro, listaProdutos, informacoesBusca} = useSelector(state=> state.gestaoProdutoReducer);
    const dispatch = useDispatch()
    const [editando, setEditando] = useState(false);
    const [produtoEditar, setProdutoEditar] = useState(false);

    const [openConfirmaRemocao, setOpenConfirmaRemocao] = useState(false);

    const {buscarProdutoPorUUID, removeProdutos, buscarProdutos} = useProduto(getApi);

    const [removendo, setRemovendo] = useState(false);
    
    

    let ativaEditar = false;
    let ativaDeletar = false;

    if(produtosSelecionados.length == 1){
        ativaEditar = true;
    }

    if(produtosSelecionados.length > 0){
        ativaDeletar = true;
    }

    const editarProdutoHandleClick = async()=> {
        setEditando(true);
        try{
            
            const produtoHidratado = await buscarProdutoPorUUID(produtosSelecionados[0].uuid);
            setProdutoEditar(produtoHidratado);
            setCadastroProdutoKey(cadastroProdutoKey+1);
            setCadastroProdutosAberto(true);
        } catch(err){
            console.log(err);
        }

        setEditando(false);
    }

    const onSalvarProdutos = async (produto)=> {
        setCadastroProdutosAberto(false);
        setTimeout(()=> {

            success({
                message: "Muito bem",
                description: `Produto "${produto.props.descricao}" salvo com sucesso`
            })
        }, 100)
    }

    const removeProdutosHandleClick = async()=> {
        setRemovendo(true);
        const listaProdutosARemover = produtosSelecionados.map(produto => produto.uuid);
        try{
            await removeProdutos(listaProdutosARemover);
            setRemovendo(true);

            let cont = 0;
            const novaListaProdutos = [];
            const removido = 0;
            for(const p of listaProdutos){
                if(!(listaProdutosARemover.includes(p.uuid))){
                    novaListaProdutos.push(p);
                }
                cont++;
            }
            dispatch(atualizaListaProdutos({
                dados: novaListaProdutos,
                info: {
                    qtdProdutos: informacoesBusca.qtdProdutos - listaProdutosARemover.length
                } 
            }))
            // dispatch(atualizaBuscandoProdutos(true));

            // const dados = await buscarProdutos(filtro);

            // dispatch(atualizaListaProdutos(dados));
        } catch(err){
            console.log(err);
        }
        setRemovendo(false);
        setOpenConfirmaRemocao(false);
        dispatch(atualizaBuscandoProdutos(false));


    }
    
    let cadastroProduto =  <FormularioCadastroProduto onSave={onSalvarProdutos} key={cadastroProdutoKey} getApi={getApi} {...formCadastroProdutoProps} onCancel={()=>{setCadastroProdutosAberto(false)}} type="modal" visible={cadastroProdutosAberto}></FormularioCadastroProduto>

    if(produtoEditar){
        cadastroProduto = <FormularioCadastroProduto onSave={onSalvarProdutos} key={cadastroProdutoKey} getApi={getApi} initialValue={produtoEditar} {...formCadastroProdutoProps} onCancel={()=>{setCadastroProdutosAberto(false)}} type="modal" visible={cadastroProdutosAberto}></FormularioCadastroProduto>
    }

    return [<Row style={{"marginTop":"10px"}} gutter={[2,2]} justify="end">

        <Col><Button {...createProps} onClick={()=>{
            setCadastroProdutoKey(cadastroProdutoKey+1);
            setProdutoEditar(false);
            setProdutoEditar({});
            setCadastroProdutosAberto(true)
        }}>Novo</Button></Col>
        <Col><Button {...editProps}  disabled={!ativaEditar} onClick={editarProdutoHandleClick}>Editar</Button></Col>
        <Col>
            <Popover title="Tem certeza que deseja excluir?" 
                open={openConfirmaRemocao}
                trigger="click"
                placement="bottomLeft"
                content={
                    <Row justify="end">
                        <Col span={24}>
                            <p>Essa ação não poderá ser desfeita</p>
                        </Col>
                        <Divider></Divider>
                        <Col>
                            <Button onClick={()=> {setOpenConfirmaRemocao(false)}}>Não</Button>&nbsp;
                        </Col>
                        <Col>
                            <Button loading={editando} onClick={removeProdutosHandleClick} danger>SIM</Button>
                        </Col>
                    </Row>
                } 
                
            >

                <Button {...deleteProps} loading={removendo} disabled={!ativaDeletar} onClick={()=> {setOpenConfirmaRemocao(true)}}>Deletar</Button>    

            </Popover>
        </Col>
    </Row>,

    
     cadastroProduto
    ] 
}

export {AcoesCrudProduto};